import { useNavigate } from "react-router"
import { motion } from "framer-motion"
import bannerHomeUrl from "@/assets/banners/banner-home.png"

export function HeroBanner() {
  const navigate = useNavigate()

  return (
    <section className="w-full">
      <div className="relative aspect-video w-full overflow-hidden bg-accent/20 sm:aspect-[2/1] xl:aspect-[21/9]">
        <img
          src={bannerHomeUrl}
          alt="Nhà Cam Homestay"
          className="absolute inset-0 size-full object-cover object-center"
          loading="eager"
          fetchPriority="high"
        />

        {/* Darkening overlay để chữ nổi bật trên ảnh nền */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"
        />

        {/* Hero content overlay: tiêu đề + mô tả + CTA */}
        <div className="pointer-events-none absolute inset-0 z-10 flex flex-col items-center justify-center px-6 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="font-hero-title text-white leading-none drop-shadow-[0_2px_18px_rgba(0,0,0,0.45)]"
            style={{ fontSize: "clamp(3.5rem, 12vw, 8rem)" }}
          >
            Nhà Cam
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}
            className="mt-3 max-w-2xl text-sm text-white/90 drop-shadow-[0_1px_8px_rgba(0,0,0,0.5)] sm:text-base md:text-lg"
          >
            Tận hưởng những phút giây thư giãn bên người yêu và gia đình tại Nhà Cam
          </motion.p>

          <motion.button
            type="button"
            onClick={() => navigate("/dat-phong")}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3, ease: "easeOut" }}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            className="pointer-events-auto mt-7 rounded-2xl border border-white/80 bg-white/10 px-8 py-3 text-xs font-semibold uppercase tracking-widest text-white shadow-lg backdrop-blur-sm transition-colors hover:bg-white hover:text-[#2E2823] sm:text-sm cursor-pointer"
          >
            Đặt phòng ngay
          </motion.button>
        </div>
      </div>
    </section>
  )
}
